import RichTextParser from './RichTextParser';
export default RichTextParser;
